import { Pipe, PipeTransform } from '@angular/core';
import { Station } from '@models/responses/station-response.model';

@Pipe({
  name: 'stationName',
  standalone: true,
})
export class StationNamePipe implements PipeTransform {
  transform(stationCode: string | undefined, stations: Station[]): string {
    return stations.find((s) => s.stationCode === stationCode)?.fullName ?? '';
  }
}
